<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <section class="section-top progress">
      <h1 class="section-top-title">隱私權保護政策</h1>
    </section>
    <section class="section-terms section">
      <div class="section-content">
        <div v-if="privacyTerm" v-html="md.render(privacyTerm)"></div>
      </div>
    </section>
  </div>
</template>
<script>
import policyAPI from "@/apis/policy";
import Loading from "@/components/Loading.vue";
import markdownit from "markdown-it";

export default {
  name: "Privacy",
  components: {
    Loading,
  },
  data() {
    return {
      md: null,
      privacyTerm: "",
      isLoading: true,
    };
  },
  created() {
    this.md = markdownit();
    this.getPolicy();
  },
  beforeRouteUpdate() {
    this.getPolicy();
  },
  methods: {
    async getPolicy() {
      try {
        this.isLoading = true;
        let { data, status } = await policyAPI.policy.privacy();
        if (status !== 200) {
          throw new Error(status);
        }
        let { term } = data[0];
        this.privacyTerm = term;
        this.isLoading = false;
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>
